import request from "../../untils/request";

export function selectList(param) {

    return request({
        url: '/userModule',
        method: 'get',
        params: param
    })
}



export function add(data) {

    return request({
        url: '/userModule',
        method: 'post',
        data: data
    })
}


